"use strict";

angular.module("customer")
.component("inventorySuggestedQuantity", {
    bindings: {
        quantity: "=",
        catalogEntry: "=",
        hasFocus: "=",
        vendor: "=",
        hideButton: "<?"
    },
    templateUrl: require("./inventory-suggested-quantity.component.html"),
    controller: function($scope, StocksService, CartItemService) {
        $scope.hideButton = this.hideButton;

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.quantity);
        };

        this.isOrderedButtonDisabled = function() {
            return StocksService.isOutOfStock(this.catalogEntry) && parseFloat(this.catalogEntry.order_quantity) === 0;
        };

        this.isCartItemQuantityValid = function() {
            var catalogEntry = this.catalogEntry;
            return CartItemService.isCartItemQuantityValid(catalogEntry.quantity_min, catalogEntry.quantity_max, catalogEntry.order_quantity);
        };

        this.addProductToCartFromSuggestedValue = function() {
            var catalogEntry = this.catalogEntry;
            var product = catalogEntry.product;
            var orderQuantity = (product.inventory_product.suggested > 0) ? product.inventory_product.suggested : 0;
            var currentQuantity = catalogEntry.order_quantity;

            if (currentQuantity !== product.inventory_product.suggested) {
                CartItemService.saveSaleQuantity(catalogEntry, null, orderQuantity, this.vendor)
                .then(function onSuccess(){
                    catalogEntry.order_quantity = orderQuantity;
                });
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/inventory/inventory-suggested-quantity.component.js
// module id = 798
// module chunks = 0